import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import swal from "sweetalert";
import DataTable from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import {createService} from "../../services/seriesService";
import AddButton from "../../components/AddButton";
import {withTranslation} from "react-i18next";
import DeleteButton from "../../components/DeleteButton";
import EditButton from "../../components/EditButton";
import Loading from "../../components/loading";
import SearchInput from "../../components/search/SearchInput";
import {useContext} from "react";
import {Context} from "../../context/SearchContext";
import {toast} from "react-toastify";
import {deleteFilling} from "../../services/fillingService";
import TempDataTable from "../../components/TemDataTable";

const headerTable = [{
    name: "id", sort: false
}, {
    name: "name", sort: true
}, {
    name: "description", sort: true
}, <span className="sr-only">Edit</span>,];

const bodyTable = ["id", "name", "description", "actions"];
const Series = ({t}) => {

    const ctx = useContext(Context);
    const {token} = useSelector((state) => state.user);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [itemOffset, setItemOffset] = useState(localStorage.getItem("itemOffset") ? parseInt(localStorage.getItem("itemOffset")) : null);;
    const [forcePage, setForcePage] = useState(localStorage.getItem("forcePage") ? parseInt(localStorage.getItem("forcePage")) : null);;
    const [sortColumn, setSortColumn] = useState("id");
    const [sortDir, setSortDir] = useState("DESC");
    const [clear, setClear] = useState(false);
    const [data, setData] = useState({
        data: [],
        recordsTotal: 0,
        pageCount: 1,
    });
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const oldSelectedId = localStorage.getItem("selectedId") ? parseInt(localStorage.getItem("selectedId")) : null
    const [selectedId, setSelectedId] = useState(oldSelectedId);
    useEffect(() => {
        localStorage.setItem("itemOffset", JSON.parse(itemOffset));
        localStorage.setItem('selectedId', JSON.parse(selectedId));
        localStorage.setItem('forcePage', JSON.parse(forcePage));
    }, [selectedId, itemOffset]);

    const handlePageClick = (event) => {
        setForcePage(event.selected);
        const newOffset =
            (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
        setItemOffset(newOffset);
    };

    const onDeleteItem = async (id) => {
        const responseReceived = await swal({
            title: t(`action.delete_item.title`),
            text: t(`action.delete_item.text`),
            icon: "warning",
            buttons: {
                cancel: true,
                confirm: true,
            },
        });
        if (responseReceived) {
            setIsLoading(true);
            const response = await deleteFilling(
                `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/series/${id}`,
                token
            );
            if (response.success) {
                fetchData();
                toast.success(t('action.delete_success'), {
                    position: "bottom-right",
                    autoClose: 3000,
                    closeOnClick: true,
                    className: "add-success"
                });
            } else {
                setIsLoading(false);
                if (response.status === 420) {
                    toast.warn(response.body.error, {
                        position: "bottom-right",
                        autoClose: 10000,
                        closeOnClick: true,
                        className: "product-background",
                        pauseOnHover: true,
                    });
                } else {
                    navigate("/error", {
                        state: {
                            status: response.status,
                            message: response.body ? response.body.error : "Error",
                        },
                    });
                }
            }
        } else {
            return;
        }
    };

    const onEditItem = (id) => navigate(`/series/update/${id}`);

    const fetchData = async () => {
        const response = await createService(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/series/table`,
            token,
            {
                draw: 1,
                start: itemOffset,
                length: itemsPerPage,
                recordsTotal: 0,
                columns: [],
                order: [{column: sortColumn, dir: sortDir}],
                search: {value: ctx.state, regex: true},
                filter: {},
            }
        );
        if (response.success) {
            setIsLoading(false);
            setClear(false);
            let reviewData = response.data.data.map((item, index) => {
                return {
                    id: index + 1,
                    name: item.name,
                    description: item.description,
                    actions: (
                        <>
                            <EditButton onclick={() => onEditItem(item.id)}/>
                            <DeleteButton onclick={() => onDeleteItem(item.id)}/>
                        </>
                    ),
                };
            });
            setData({
                data: reviewData,
                recordsTotal: response.data.recordsFiltered,
                pageCount: Math.ceil(
                    response.data.recordsFiltered / parseInt(itemsPerPage)
                ),
            });
        } else {
            setIsLoading(false);
            navigate("/error", {
                state: {
                    status: response.status,
                    message: response.message ? response.message : null,
                },
            });
        }
    };

    useEffect(() => {
        if (clear) {
            fetchData();
        }
    }, [clear]);

    useEffect(() => {
        fetchData();
    }, [itemOffset, itemsPerPage, ctx.state]);

    const sortFunction = (value) => {
        setSortColumn(value.field ? value.field : "id");
        setSortDir(value.sort === true ? 'ASC' : 'DESC');
        setClear(true);
    }

    return (
        <>
            {isLoading ? (
                <Loading/>
            ) : (
                <div className="px-4 py-4 sm:px-6 lg:px-8">
                    <div className="mb-2 sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-xl font-semibold text-gray-900">
                                {t(`series`)}
                            </h1>
                        </div>
                        <AddButton title={t(`add_series`)} url={"add"}/>
                    </div>
                    <div>
                        <div className="flex justify-between items-center">
                            <Select
                                setItemsPerPage={setItemsPerPage}
                                itemsPerPage={itemsPerPage}
                            />
                            <SearchInput/>
                        </div>
                        <TempDataTable
                            data={data.data}
                            headerTable={headerTable}
                            bodyContent={bodyTable}
                            sortFunction={sortFunction}
                            selectedRowId={selectedId}
                            rowHandler={(id) => {
                                setSelectedId(id);
                            }}
                        />
                        <Pagination
                            handlePageClick={handlePageClick}
                            pageCount={data.pageCount}
                            forcePage={forcePage}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default withTranslation()(Series);
